export const PlusIcon = ({ ...props }) => {
  return (
    <svg height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="m13 12h5.5c.2761424 0 .5.2238576.5.5s-.2238576.5-.5.5h-5.5v5.5c0 .2761424-.2238576.5-.5.5s-.5-.2238576-.5-.5v-5.5h-5.5c-.27614237 0-.5-.2238576-.5-.5s.22385763-.5.5-.5h5.5v-5.5c0-.27614237.2238576-.5.5-.5s.5.22385763.5.5z" />
    </svg>
  );
};
